.orgGrid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: var(--size-5);
	width: 100%;
	overflow-y: auto;
}

.orgCard {
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	gap: var(--size-5);
	padding: var(--size-5);
	text-align: left;
	color: var(--color-text);

	transition: background-color 0.25s;
	&[data-accessible="true"]:has(> .orgOverlay:hover, > .orgOverlay:focus-visible) {
		background-color: var(--color-surface-hover);
	}

	&[data-accessible="false"] > .orgInfo {
		opacity: 0.5;
	}
}

.orgOverlay {
	position: absolute;
	inset: 0;
	z-index: 1;
	border-radius: inherit;
}

.orgInfo {
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	gap: var(--size-5);
}

.orgName {
	flex: 1;
	font-weight: 600;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.orgMenu {
	position: relative;
	z-index: 2;
}

.newOrgCard {
	width: 100%;
	height: 100%;
	min-height: calc(32px + var(--size-5) * 2);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--size-3);
	padding: var(--size-5);
	border: 2px dashed var(--color-border);
	border-radius: var(--radius-lg);
	color: var(--color-text-subtle);
	font-weight: 600;
	cursor: pointer;
	transition:
		color 0.25s,
		border-color 0.25s,
		background-color 0.25s;

	&:where(:hover, :focus-visible) {
		color: var(--color-text);
		border-color: var(--color-text-subtle);
		background-color: var(--color-surface-hover);
	}
}
